import { useController, Control } from 'react-hook-form';
import BaseSelect, { OptionSelect } from '.';

interface ReactHookFormSelectProps {
  name: string;
  control: Control<any>;
  label?: string;
  options: OptionSelect[];
  disabled?: boolean;
  [key: string]: any;
}

export default function ReactHookFormSelect({
  name,
  control,
  label,
  options,
  disabled,
  ...props
}: ReactHookFormSelectProps) {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ name, control });

  return (
    <BaseSelect
      name={name}
      label={label}
      value={value}
      onChange={onChange}
      options={options}
      disabled={disabled}
      errorMessage={error?.message}
      {...props}
    />
  );
}
